import './index.scss';
import 'components/modals/login_register_modal';
import 'utils/modal_manager';
import 'utils/permissions/permissions';
import 'utils/trackers';
import 'utils/trackers/user';

(async () => {
  if (gon.track) {
    UserTracker.emit('builderPageVisited', {
      pageName: gon.track,
      campaignType: gon.track_type || 'Generic'
    });
  }
})();
